export default "__VITE_ASSET__518533ef__"